// @flow
/* eslint-disable max-params */

import {Vector2D} from '../Vector2D/vector2d'
import type {vector} from '../Vector2D/vector2d'
import type {Move, Pose} from '../tracer'

export class PathGenerator {
  radius: number
  columnGap: number
  marginH: number
  marginV: number
  columnWidth: number

  constructor(
    radius: number,
    columnGap: number,
    marginH: number,
    marginV: number
  ) {
    this.radius = radius
    this.columnGap = columnGap
    this.marginH = marginH
    this.marginV = marginV
    this.columnWidth = 2 * radius + columnGap
  }

  leftEdge({position, direction}: Pose) {
    const left = Vector2D.rotate(direction, -Math.PI / 2)
    return this.getCoordinates(position, left)
  }

  getCoordinates(position: vector, edgeOffset: vector) {
    const x =
      this.radius +
      this.marginH +
      this.columnWidth * position[0] +
      edgeOffset[0] * this.radius
    const y =
      this.radius +
      this.marginV +
      this.columnWidth * position[1] +
      edgeOffset[1] * this.radius
    return [x, y]
  }

  toPath(moves: Array<Move>): string {
    const start = this.leftEdge(moves[0].from)
    return [
      `M ${start[0]} ${start[1]}`,
      ...moves.map(move => {
        if (move.type === 'forward' || move.type === 'two forward') {
          const to = this.leftEdge(move.to)
          return `L ${to[0]} ${to[1]}`
        } else if (move.type === 'rotate right') {
          const to = this.leftEdge(move.to)
          return `A ${this.radius} ${this.radius} 0 0 1 ${to[0]} ${to[1]}`
        } else if (move.type === 'diagonal left') {
          const to = this.leftEdge(move.to)
          return `A ${this.radius + this.columnGap} ${this.radius +
            this.columnGap} 0 0 0 ${to[0]} ${to[1]}`
        }

        throw new Error('Unknown move')
      }),
      'Z'
    ].join(' ')
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/mandat-svg/PathGenerator/path-generator.js